module.exports = __webpack_public_path__ + "5028a495d5ec13af2a1003e6d055cffb.pdf";